import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../api';
import { Empty, ErrorBox, Loading, dt } from '../../ui';

interface Event { id: string; at: string; action: string; by?: string; viaStation?: boolean; entity: { kind: string }; reason?: string }

export function Audit() {
  const [params] = useSearchParams();
  const qs = params.toString();
  const q = useQuery({ queryKey: ['audit', qs], queryFn: () => api.get<Event[]>(`/api/audit${qs ? `?${qs}` : ''}`) });
  return (
    <div className="card">
      <h1>History of changes</h1>
      <p className="muted">Every approval, supply, payment, limit change and correction, with who did it and when. Only events for your business are shown.</p>
      {q.isLoading ? <Loading /> : <ErrorBox error={q.error} />}
      {q.data && !q.data.length ? <Empty>No events.</Empty> : null}
      <div className="table-wrap">
        <table>
          <thead><tr><th>When</th><th>What</th><th>Who</th><th>Reason</th></tr></thead>
          <tbody>
            {q.data?.map((e) => (
              <tr key={e.id}>
                <td>{dt(e.at)}</td>
                <td>{e.action.replace(/[._]/g, ' ')}<div><small>{e.entity.kind}</small></div></td>
                <td>{e.by ?? 'system'}{e.viaStation ? <small> (pump device)</small> : null}</td>
                <td>{e.reason}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
